import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { useDispatch, useSelector } from 'react-redux'
import { ERROR_ACTION, GET_ID_VERIFICATION_SUCCESS, LOAD_ACTION } from './IDVerificationPopUpConstants'
import { getErrorMessage } from './IDVerificationPopUpActions'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const IDVerificationPopUpListener = ({ tabId, patientId, onOpenFileVerification, onSetLoading, setToastMessage }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action) => {
          switch (action.type) {
            case LOAD_ACTION:
              onSetLoading(true)
              break
            case GET_ID_VERIFICATION_SUCCESS:
              if (action.extraData.tabId === tabId || patientId === action.extraData.patientId) {
                onSetLoading(false)
                onOpenFileVerification({ ...action.payload, PatientId: action.extraData.patientId })
              }
              break

            case ERROR_ACTION:
              onSetLoading(false)
              setToastMessage(getErrorMessage(action))
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return null
}

export default IDVerificationPopUpListener
